import api from './api';

export const bankService = {
  createBankInfo: async (formData, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.post('/bankinfo/', { ...formData }, { headers });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};
